/**
 * Tipos y formato de precios — **sin dependencias de servidor**. Vive aparte de `lib/planes.ts`
 * a propósito: ese importa `pg` (base de datos) y `pricing-tabs.tsx` es un client component, así
 * que importar el formateador desde allá arrastraba el driver de PostgreSQL al bundle del
 * navegador y rompía el build ("Can't resolve 'dns'/'util/types'"). Todo lo que necesite el
 * cliente va acá; lo que toca la base va en `lib/planes.ts`.
 */

export type PlanRow = {
  sistema: string;
  nivel: string;
  nombre: string;
  precio_mensual: number;
  precio_anual: number;
  destacado: boolean;
  features: string[];
  /** Tope de ingresos mensuales del plan, en COP. `null` en Nómina, que se segmenta por empleados. */
  limite_ingresos_mes: number | null;
  /** 📸 Fotos de producto con IA al mes (2026-10-05). 0 = no las incluye (Nómina). Se cambia en `admin › Planes`. */
  limite_fotos_ia_mes: number;
  /** 🎙️ Minutos del asistente de voz Premium al mes (2026-10-06; el Básico es gratis y sin topes). Se cambia en `admin › Planes`. */
  limite_minutos_voz_mes: number;
};

export const formatCOP = (value: number) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
